import React from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/app.css'
import App from '../components/App.jsx'

const el = document.getElementById('root')
if (el) createRoot(el).render(<App />)
